"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const setHrefTarget = (link) => {
    const linkUrl = new URL(link);
    const linkHost = linkUrl.hostname;
    const linkPort = linkUrl.port;
    const appHost = window.location.host;
    const linkBasePath = linkUrl.port ? `${linkHost}:${linkPort}` : linkHost;
    return linkBasePath === appHost ? "_self" : "_blank";
};
exports.default = setHrefTarget;
//# sourceMappingURL=links.js.map